import { fetchWithToken } from "../../api/apiBase";
import ProjectForm from "../projects/CreateProject";
import {
  useAuthInfo,
} from "@propelauth/react";
import { useParams } from "react-router-dom";
import {useEffect, useState} from "react";
import {Project} from "../../models/project";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {useToast} from "../../hooks/use-toast";

/*
 * Wrapper for the Edit/Create Project form
 *
 * */
function EditProject() {
  const { project_id } = useParams<{ project_id: string }>();
  const {accessToken} = useAuthInfo()
  const [data, setData] = useState<Project | null>(null);
  const {toast} = useToast()

  useEffect(() => {
    if(accessToken) {
      fetchWithToken(`/projects/${project_id}`, accessToken)
          .then((x) => {
            setData(x)
          }).catch((err) => {
            toast({
                title: "Error",
                description: "Could not load project",
                variant: "destructive",
            })

          })
    }
    }, [project_id])

  //if (isLoading) return <div>Loading...</div>;
  //if (error) return <div>Error loading project</div>;
  if(!data){
    return <div><BaseLoadingSpinner/></div>;
  }
  return <ProjectForm project_id={project_id as string} project={data} />;
}

export default EditProject;
